import apiProduct from '@/api/vo/product';

const defaultState = () => ({
	listProductAll: [],
	listProductMitra: [],
});

const state = defaultState();

const getters = {};

const mutations = {
	setListProductAll(state, data) {
		data.data.map( (el) => {
			el['quantity'] = 1
			el['checked'] = false
			el['total'] = el.quantity * el.product_member_price
			return el;
		});
		state.listProductAll = data.data;
	},
	setListProductMitra(state, data) {
		data.data.map( (el) => {
			el['quantity'] = 1
			el['checked'] = false
			el['total'] = el.quantity * el.product_member_price
			return el;
		});
		state.listProductMitra = data.data;
	},
};

const actions = {

	getProductAll({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiProduct.getProductAll(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setListProductAll', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setListProductAll', []);
				reject()
			});
		});
	},

	getProductMitra({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiProduct.getProductMitra(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setListProductMitra', data.results)
					resolve(data.results)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setListProductMitra', []);
				reject()
			});
		});
	},

	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},

	errorHandler({ commit }, response) {
		if (response.status !== undefined && response.status === 'unauthorized') {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.msg
			}, { root: true });
		} else {
			switch (response.error_code) {
				case 'validationError':
					commit('setErrorValidation', response.results.validationMessage)
					break;
					
				case 'ERROR':
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: response.message
					}, { root: true });
					break;
						
				default:
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					}, { root: true });
					break;
			}
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};